import ICalendarEvent from "../../../types/ICalendarEvent";

type Props = {
  timeText: string;
  event: {
    title: string;
    extendedProps: Partial<ICalendarEvent> & {
      screeningEvent?: {
        docReq?: string | null;
        docExpert?: string | null;
        lieu?: string | null;
         campaignId?: {
          _id: string;
          nbJournees: number;
          createdAt: string;
          updatedAt: string;
          clientId?: {
            _id: string;
            name: string;
          };
        };

      };
    };
    [property: string]: any;
  };
};

const CalendarEvent: React.FC<Props> = (props) => {
  const screeningEvent = props.event.extendedProps?.screeningEvent;

  const hasDocReq = !!screeningEvent?.docReq;
  const hasDocExpert = !!screeningEvent?.docExpert;
  const isComplete = hasDocReq && hasDocExpert;
  const status = isComplete
    ? "Planifiée"
    : "Affectation(s) à faire";
  return (
    <>
      <div
      className={`
        w-full rounded-md border-l-4 p-2 text-xs shadow-sm
        ${isComplete
          ? "bg-green-50 border-green-500"
          : "bg-orangeCustom border-orange-600"}
      `}
    >
      {/* Title */}
      <div className="font-semibold text-gray-900 truncate">
        {screeningEvent?.campaignId?.clientId?.name ?? "Client"}
      </div>

      {/* Location */}
      <div className="text-gray-600 truncate">
        {screeningEvent?.lieu || "Lieu non défini"}
      </div>

      {/* Status */}
      <div className="mt-1 flex overflow-hidden">
        <span
          className={`
            px-2 py-0.5 rounded-full text-[10px] font-semibold
            ${isComplete
              ? "bg-green-200 text-green-800"
              : "bg-red-200 text-red-800"}
          `}
        >
          {status}
        </span>
      </div>
    </div>
    </>
  );
};

export default CalendarEvent;
